export default "__VITE_ASSET__DE7tl4Ej__"